import { createActionTypes } from 'utils/action/actionTypes';

export const LOGIN = createActionTypes('LOGIN');
export const FORGOT_PASSWORD = createActionTypes('FORGOT_PASSWORD');
export const CHANGE_PASSWORD = createActionTypes('CHANGE_PASSWORD');
export const LOGIN_WITH_OTP = createActionTypes('LOGIN_WITH_OTP');
export const CREATE_NEW_PASSWORD = createActionTypes('CREATE_NEW_PASSWORD');
export const TENANT_ADMIN_LOGIN = createActionTypes('TENANT_ADMIN_LOGIN');
export const TENANT_ADMIN_LOGIN_AS = createActionTypes('TENANT_ADMIN_LOGIN_AS');
export const CHANGE_EXPIRED_PASSWORD = createActionTypes('CHANGE_EXPIRED_PASSWORD');
